import {
  SEND_INFO_FILE_UPLOADED_CUSTOMERS,
  REQUEST_IMPORT_DATA_TO_CUSTOMERS
} from './constants'

/**
 * post file as a formdata to mokapos-*.s3.amazonaws.com/
 * @param formdata
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function uploadToS3 (url, formData) {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } }
  return axios
     .post(url, formData, config)
     .then(response => {
       return Promise.resolve(response)
     }).catch(error => {
       return Promise.reject(new Error(error))
     })
}

/**
  * send information to server about file has been saved to s3
  * @param uploadFile
  * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
  */
export function sendSuccessUploadCustomers (url) {
  return axios
     .post(SEND_INFO_FILE_UPLOADED_CUSTOMERS, { uploadfile: url }, { withCredentials: true })
     .then(response => {
       return Promise.resolve(response)
     }).catch(error => {
       return Promise.reject(new Error(error))
     })
}

export function requestImportDataToCustomers () {
  return axios
    .post(REQUEST_IMPORT_DATA_TO_CUSTOMERS, {}, { withCredentials: true })
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      const {response} = error
      return Promise.reject(response)
    })
}



// WEBPACK FOOTER //
// ./app/api/uploaders/index.js